@if (!hidden) {
  <span class="ai-insights-unread-badge" [attr.aria-label]="count + ' open AI insights'">{{ count }}</span>
}
